module.exports = __webpack_public_path__ + "img/bookshelf18.c9a12c8b.jpg";